<template>
    <div>
        <div v-if="wishlist.length">
            <div class="d-flex mb-3">
                <div class="btn btn-primary" @click="addWishlistProducts"><i class="fas fa-shopping-bag fa-fw"></i> {{t.wishlist.add_all_to_cart}}</div>
                <div class="ms-auto">
                    {{ t.product.share }}
                    <div id="share"
                    class="btn btn-sm btn-link d-md-none"
                    :data-url="url('wishlist')+'?products='+pluck(this.wishlist, 'id').join()" :data-title="t.wishlist.share_title"
                    :data-description="t.wishlist.share_description"><i class="fas fa-share-alt-square fa-2x"></i></div>
                    <div id="share-copy"
                    class="btn btn-sm btn-link d-none d-md-inline-block"
                    :data-url="url('wishlist')+'?products='+pluck(this.wishlist, 'id').join()"><i class="fas fa-share-alt-square fa-2x"></i></div>
                </div>
            </div>
            <div v-for="product in wishlist" :key="product.id" class="row mb-3 position-relative">
                <div class="col-4 col-md-2 pe-0">
                    <a :href="product.url">
                        <img :src="product.thumbnail" class="img-fluid" alt="">
                    </a>
                </div>
                <div class="col bg-light p-3 d-flex align-items-center">
                    <div>
                        <div class="mb-1">
                            <a class="h5" :href="product.url">
                                {{product.name}}
                            </a>
                            <span v-if="config.modules.stock && !product.is_product_group && product.stock <= 0">({{ settings.order_out_of_stock ? t.product.restocking : t.product.out_of_stock}})</span>
                        </div>
                        <div class="mb-3 d-none d-md-block" v-html="product.description"></div>
                        <div class="mb-3 d-block d-md-none" v-html="truncateText(product.description, 30)"></div>
                        <add-to-cart-component :data-product="product"></add-to-cart-component>
                    </div>
                </div>
                <div class="btn btn-link position-absolute top-0 end-0 w-auto" @click="toggleToWishlist(product.id)"><i class="fas fa-trash fa-lg"></i></div>
            </div>
        </div>
        <div v-else class="alert alert-warning">
            {{t.wishlist.empty_wishlist}}
        </div>
    </div>
</template>
<script>
import store from "../CartStore";
export default {
    props: ['dataWishlist'],
    store: store,
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            wishlist: this.dataWishlist
        }
    },
    methods: {
        toggleToWishlist(product_id) {
            axios
            .post("/ajax/wishlist/toggleToWishlist", {
                id: product_id
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response) => {
                Vue.notify({text: response.data.message.text, type: response.data.message.type})
                this.wishlist = response.data.wishlist
                this.$root.$emit("updateWishlist", response.data.wishlist);
            });
        },
        addWishlistProducts() {
            axios
            .post("/ajax/cart/add-wishlist-products")
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response) => {
                if(response.data.type == 'success') {
                    // commit function to add to the store
                    store.state.cart = response.data.cart
                }
                Vue.notify({text: response.data.message, type: response.data.type})
                store.state.loading = false
            });
        },
    },
}
</script>
